import { message } from "antd";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { setTemplateData, setServerData } from "../app/EditorSlice";
import { padServices } from "../api";

const HARDCODED_TOKEN = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiNzJBNEQ2OUQtNDgzMS00NzhGLUFFMDQtRUQ0ODI1MDlGRTkxIiwiaWgiOiI3M3FqQ1BSWDdIcUptK2F3UXJVbWtuR0xvTjM0dDM5K0NuYkJCRjVSU29FPSIsImlzIjoicTg0S2J3MS84TUFuWXBGcGpGekpsdz09IiwicGgiOiJrNTJ6bDZVakdRMmpqVGhRVUV0ZEV4UEl0WXB3eXhtMjhKYlp0VlJiYkhZPSIsInBzIjoiejlZSTI4Z2VqL0w3N3FSRFdQK0tKUT09IiwianRpIjoiYzE5NTBlMDktNWZjNS00NTExLThjYWItMmY1MTIzODNmYWU4IiwibmJmIjoxNzY1NjIxNzkyLCJleHAiOjE3NjU3OTQ1OTJ9.CGsjXdPJjgRB8IwEqLKN2f-Of6cA3wjc4GNhuyaPPSa0VJVqpx1H2nmdYtIUp4qak6Hx5n6lPJto8qpodE0aLcjArmnu55QEylGpV0IaqsQUwKp4ysWsajNl3tfeoT1Wx8tmcFMDbjppoEEVCCxCf1unLhhMbLrNihEXvcK6IQDjR3qrGiCZyCjFRxzWoQ3vlPoziOQ7a9VMdLZlTpSEv79nArLrnWN3Ydg4aqKPg5o-hmYUtyy8i7Io6TJJ8PAgEli9TYkcWT0O0MavRBp35lrUGvVnGGhMeEGTGY83q7HVrrRL9iWdfXp31ukHoUJYsKd1zmJAH4GoVIz5yw67xA";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || HARDCODED_TOKEN;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export const generateHtml = (contentState) => {
  let rawContentState = convertToRaw(contentState);
  rawContentState.blocks = rawContentState.blocks.map(block => {
    if (block.type.startsWith('header')) {
      if (!block.data.id) {
        block.data.id = `heading-${block.key}`;
      }
    }
    const newData = {
      ...block.data,
      ...(block.data.lineHeight ? { lineHeight: block.data.lineHeight } : {}),
      ...(block.data.textAlignment ? { 'text-align': block.data.textAlignment } : {}),
    };
    return {
      ...block,
      data: newData
    };
  });
  // Convert to HTML
  const htmlWithIDs = draftToHtml(rawContentState);
  return htmlWithIDs;
};

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};

export const adjustEditorHeightWithSignatures = (signatures) => {
  let pageContainer = document.getElementById('lexical-editor-container');
  if (!signatures || signatures.length === 0 || !pageContainer) {
    return;
  }
  const greatestTopSignature = signatures.reduce((max, signature) => {
    const currentTop = parseInt(signature?.signatureBoxStyle?.top, 10) || -Infinity;
    return currentTop > max.top ? { signature, top: currentTop } : max;
  }, { signature: null, top: -Infinity }).signature;
  if (greatestTopSignature) {
    const top = parseInt(greatestTopSignature.signatureBoxStyle.top, 10) || 0;
    const pageHeight = pageContainer.clientHeight;
    if (pageHeight < top) {
      pageContainer.style.minHeight = `${top + 100}px`;
    }
  }
};

export const showPagebreak = () => {
  const pageContainer = document.getElementById('lexical-editor-container');
  const editorContainer = document.getElementById('lexical-pages-container');
  if (!pageContainer || !editorContainer) return;

  // Remove existing page break lines
  document.querySelectorAll('.page-break').forEach(breakElement => breakElement.remove());

  // initial height of one "page"
  const initialPageHeight = 1180;

  // actual content height
  const contentHeight = pageContainer.scrollHeight;

  // number of pages based on content height
  const numberOfPages = Math.floor(contentHeight / initialPageHeight);

  if (contentHeight > initialPageHeight) {
    for (let i = 1; i <= numberOfPages; i++) {
      const pageBreakLine = document.createElement('div');
      pageBreakLine.className = 'page-break';
      pageBreakLine.style.position = 'absolute';
      pageBreakLine.style.top = `${i * initialPageHeight}px`;
      pageBreakLine.style.width = '100%';
      pageBreakLine.style.height = '8px';
      pageBreakLine.style.pointerEvents = 'none';
      pageBreakLine.style.marginLeft = '-26px';
      pageBreakLine.style.borderTop = '2px dotted #000';
      pageBreakLine.style.background = 'white';
      pageBreakLine.setAttribute('data-page-number', i);
      editorContainer.appendChild(pageBreakLine);
    }
  }
};
export const isRespectiveDocument = (documentId) => {
  const pathname = window.location.pathname;
  let id = pathname.split("/")[1];
  if (id === "external") {
    id = pathname.split("/")[2]
  }
  return id && id === documentId;
};


export const getLocationCoordinates = (success, error) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, error);
  } else {
    message.error("Geolocation is not supported by this browser.");
  }

  // function success(position) {
  //   x.innerHTML = "Latitude: " + position.coords.latitude + 
  //   "<br>Longitude: " + position.coords.longitude;
  // }
};

export const fetchIpAddress = () => {
  return new Promise((resolve, reject) => {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then((data) => resolve(data.ip))
      .catch(error => reject(error));
  });
};

export const saveToLocalStorage = (docId, data) => {
  try {
    const localData = {
      data: data,
      lastUpdateTime: new Date().toISOString()
    };
    // Retrieve existing data from localStorage or initialize with an empty object
    const existingData = JSON.parse(localStorage.getItem('offlineMilepadData')) || {};
    // Replace or add the sheet data for the given docId
    existingData[docId] = localData;
    // Save updated data back to localStorage
    localStorage.setItem('offlineMilepadData', JSON.stringify(existingData));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const removeOfflineData = (id) => {
  const offlineData = JSON.parse(localStorage.getItem('offlineMilepadData') || '{}');
  delete offlineData[id];
  localStorage.setItem('offlineMilepadData', JSON.stringify(offlineData));
};

export const safeParseEditorState = (editor, jsonStringOrObject) => {
  const defaultEmptyState = '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}';
  if (!jsonStringOrObject) {
    return editor.parseEditorState(defaultEmptyState);
  }
  try {
    // Accept either a string or already-parsed object
    let jsonString = jsonStringOrObject;
    if (typeof jsonStringOrObject !== 'string') {
      jsonString = JSON.stringify(jsonStringOrObject);
    }
    if (!jsonString || jsonString.trim() === '') {
      return editor.parseEditorState(defaultEmptyState);
    }
    return editor.parseEditorState(jsonString);
  } catch (error) {
    console.error('Failed to parse editor state:', error);
    return editor.parseEditorState(defaultEmptyState);
  }
};

export const loadTemplateIfAvailable = async ({
    searchParams,
    setSearchParams,
    id,
    dispatch,
    setContentLoading
}) => {
    const templateId = searchParams.get('templateId');

    try {
        // Fetch template data
        const serverResponse = await padServices.fetchTemplateById(templateId);
        const templateData = serverResponse?.data?.data;

        // Store template data in Redux
        dispatch(setTemplateData(templateData));

        // Prepare the data for saving
        const dataToLoad = {
            ...serverResponse?.data,
            summary: "",
            Signatures: [],
            milepadData: templateData?.milepadData || "",
        };

        // Save under current doc id
        await padServices.saveToDatabase(
            id,
            dataToLoad.milepadData,
            dataToLoad.summary,
            dispatch
        );

        // Update redux
        dispatch(setServerData(dataToLoad));

        // Remove templateId from URL
        setSearchParams((params) => {
            params.delete('templateId');
            return params;
        });

        setContentLoading(false);

        // Return loaded data
        return dataToLoad;

    } catch (err) {
        console.error("Error loading template:", err);
        return null;
    }
};